import { ChangeDetectionStrategy, Component, OnInit, computed, inject, input, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { User } from 'src/app/models/user.model';
import { ApiService } from 'src/app/services/api.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { TinymceService } from 'src/app/services/tinymce.service';

@Component({
  selector: 'app-user-detail-holidays-email-section',
  templateUrl: './user-detail-holidays-email-section.component.html',
  styleUrl: './user-detail-holidays-email-section.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule, MatButton, MatCheckbox, MatIcon, EditorComponent],
})
export class UserDetailHolidaysEmailSectionComponent implements OnInit {
  private readonly api = inject(ApiService);
  private readonly fb = inject(UntypedFormBuilder);
  private readonly permissions = inject(PermissionsService);
  private readonly tinymce = inject(TinymceService);

  readonly user_id = input.required<string>();
  readonly user = input.required<User>();
  readonly is_setup = input.required<boolean>();
  readonly its_me = input.required<boolean>();
  readonly user_updated = output<User>();

  readonly form: UntypedFormGroup = this.fb.group({
    out_of_work_mail_body: [''],
  });
  readonly tiny_mce_api_key = this.tinymce.getKey();
  readonly tiny_mce_init = {
    automatic_uploads: true,
    statusbar: false,
    menubar: false,
    block_unsupported_drop: false,
    height: '400px',
    plugins:
      'anchor autolink charmap codesample directionality help image insertdatetime link lists media nonbreaking pagebreak searchreplace table visualblocks visualchars wordcount advlist autolink lists link image charmap preview anchor searchreplace visualblocks code fullscreen insertdatetime media table emoticons codesample',
    toolbar:
      'undo redo | blocks | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | code',
  };
  readonly can_edit = computed((): boolean => this.its_me() || this.permissions.validateDepartment(['direction', 'rrhh']));
  readonly fields_disabled = computed((): boolean => !this.can_edit());
  readonly save_disabled = computed((): boolean => !this.can_edit());

  ngOnInit(): void {
    this.form.patchValue({
      out_of_work_mail_body: this.user().out_of_work_mail_body || '',
    });
  }

  save_absence_email(): void {
    const body: Record<string, unknown> = {
      out_of_work_mail_body: this.form.value.out_of_work_mail_body,
    };

    this.api.updateUser(this.user_id(), body).subscribe((updated_user: User): void => {
      this.user_updated.emit(updated_user);
    });
  }
}
